import { EStrategyDocumentStatus } from "./enum/document-status";
import { EStrategyDocumentType } from "./enum/document-type";

export class StrategyDocument {

    Version: number
    PdfElectronicDocumentId: string;
    SentOn: Date;
    Type: EStrategyDocumentType;
    Status: EStrategyDocumentStatus;

    
    static mapFromJSON(json) {
        const sd = new StrategyDocument();

        sd.Version = json['version'];
        sd.PdfElectronicDocumentId = json['PdfElectronicDocumentId'];
        sd.SentOn = json['sentOn'];
        sd.Status = json['status'];
        sd.Type = json['type'];

        return sd;
    }
}